import ShorcutModal from './ShorcutModal';

export default ShorcutModal;
